import React, { Component } from 'react'
import { StyleModal } from './style'
import { Button } from '../../../components'
import { MODAL_DELETE } from '../../../helpers'
export class ModalDelete extends Component {

  constructor(){
    super()
    this.state = {
      keyword: ''
    }
  }

  onChange = (event) => {
    this.setState({
      keyword: event.target.value
    })
  }
  render() {
    const {
      keyword
    } = this.state
    const {
      name,
      alert,
      onClickCancel,
      validate,
      onClickAction,
      language,
      noremake,
      colorTheme,
    } = this.props

    return (
      <StyleModal colorTheme={colorTheme}>
        <div className='div-Modal' />
        <div className='content-Modal'>
          <div className='sub-content'>
            <div className='head-modal'>
             {MODAL_DELETE.HEAD[language]}
            </div>
            <div className='description'>
             {MODAL_DELETE.DESCRIPTION[language](name)}
              <div>
                {
                  alert ? `${alert} ${MODAL_DELETE.SURE[language]}` : MODAL_DELETE.SURE[language]
                }
              </div>
            </div>
            {typeof noremake !== 'undefined' ? null : <input
              value={keyword}
              onChange={this.onChange}
              placeholder={MODAL_DELETE.PLACEHOLDER[language]}
              className='input-delete'
            />}

            {validate &&
              <div className='text-error'>
                {validate.description}
              </div>
            }
            <div className='tabel btn-modal'>
              <div className='table-row'>
                <div className='table-cell tabel-right'>
                  <Button
                    name={MODAL_DELETE.KEEP[language]}
                    onClick={onClickCancel}
                    className='modal-btn-keep'
                  />
                </div>

                <div className='table-cell tabel-left'>
                  <Button
                    name={MODAL_DELETE.DELETE[language]}
                    onClick={()=>{
                      onClickAction(keyword)
                    }}
                    className='modal-btn-delete is-pass'
                    colorTheme={colorTheme}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleModal>
    )
  }
}
